<div class="modal-main">
  <div
    class="header d-flex justify-content-center align-items-center position-relative pt-3 pb-3 px-4"
  >
    <h1 class="modal-title mb-0">{{ "DELETE_ACCOUNT" | translate }}</h1>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="cross-button position-absolute pointer-cursor"
      (click)="closeDialog()"
    />
  </div>

  <div class="content px-4 pt-4">
    <h2 class="confirm-title">{{ "UNABLE_TO_DELETE_ACCOUNT" | translate }}</h2>

    <p class="unable-text">
      {{ "UNABLE_TO_DELETE_ACCOUNT_PREFIX" | translate }}
      <strong>{{ "ACTIVE_PROPERTY_MANAGER_ADMIN" | translate }}</strong>
      {{ "UNABLE_TO_DELETE_ACCOUNT_SUFFIX" | translate }}
    </p>

    <ul class="site-list">
      <li *ngFor="let siteName of siteList">{{ siteName }}</li>
    </ul>

    <p class="unable-footer">
      {{ "UNABLE_TO_DELETE_ACCOUNT_FOOTER" | translate }}
    </p>

    <div class="button-container mt-4">
      <button class="btn-delete" (click)="closeDialog()">
        {{ "CLOSE" | translate | uppercase }}
      </button>
    </div>
  </div>
</div>
